import { render, staticRenderFns } from "./ChecklistComponent.vue?vue&type=template&id=dfbef522&"
import script from "./ChecklistComponent.vue?vue&type=script&lang=js&"
export * from "./ChecklistComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QExpansionItem,QSeparator,QChip,QScrollObserver,QDialog,QCardActions,QBtn,QPageSticky,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QExpansionItem,QSeparator,QChip,QScrollObserver,QDialog,QCardActions,QBtn,QPageSticky})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
